import { AUTHORITIES } from 'config'

import type { UserPayload, OperationFlowType } from 'types'

export function isAdminOrManager(user: UserPayload) {
  return (
    user.authority === AUTHORITIES.ADMIN ||
    user.authority === AUTHORITIES.MANAGER
  )
}

interface CheckGroupUserAmountParams {
  users: UserPayload[]
  operationFlowType: OperationFlowType
}
export function isGroupUserAmountEnough({
  users,
  operationFlowType,
}: CheckGroupUserAmountParams): boolean {
  if (operationFlowType === 'normal') {
    return true
  }

  let userCount = 0
  let adminCount = 0
  users.forEach((user) => {
    if (isAdminOrManager(user)) {
      adminCount++
    } else {
      userCount++
    }
  })

  if (operationFlowType === 'doubleCheckVerify') {
    return adminCount >= 1 && userCount >= 2
  }

  // tripleCheckVerify
  return adminCount >= 1 && userCount >= 3
}
